import React from 'react';
import { ArrowRight, Flame, TrendingUp, Users, Award } from 'lucide-react';
import { businessInfo } from '../data/mock';

const FinalCTA = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Olá! Quero agendar minha aula experimental e começar minha transformação!"
    );
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <section className="py-32 relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/20 via-bg-page to-bg-card"></div>
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNkYzI2MjYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMTM0aDd2LTdoLTd6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-30"></div>
      
      {/* Large decorative elements */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-brand-primary/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-brand-primary/20 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* Icono animado gigante */}
          <div className="relative inline-block mb-8">
            <div className="w-32 h-32 bg-gradient-to-br from-brand-primary to-red-700 rounded-full flex items-center justify-center mx-auto shadow-2xl shadow-brand-primary/50 animate-pulse">
              <Flame className="w-16 h-16 text-white" />
            </div>
            <div className="absolute inset-0 w-32 h-32 bg-brand-primary/30 rounded-full blur-2xl animate-ping"></div>
          </div>

          {/* Main Headline */}
          <h2 className="text-5xl lg:text-6xl font-black text-white mb-8 uppercase leading-tight">
            Sua Transformação<br />
            <span className="text-brand-primary">Começa Agora</span>
          </h2>

          {/* Subheadline con énfasis visual */}
          <p className="text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
            Pare de adiar. Pare de procurar desculpas. <span className="text-white font-bold">Esse é o momento</span> de evoluir, de se tornar mais forte, mais confiante e mais disciplinado. <span className="text-brand-primary font-bold">O primeiro passo é o mais importante.</span>
          </p>

          {/* CTA Button Grande */}
          <button
            onClick={handleWhatsAppClick}
            className="btn-primary text-2xl px-16 py-8 group mb-12 shadow-2xl shadow-brand-primary/50 hover:scale-105"
          >
            🥊 Agendar Aula Experimental Grátis
            <ArrowRight className="w-8 h-8 ml-3 group-hover:translate-x-2 transition-transform" />
          </button>

          {/* Supporting badges */}
          <div className="flex flex-wrap justify-center gap-6 mb-16">
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
              <span className="text-3xl">✓</span>
              <span className="text-white font-semibold">100% gratuita</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
              <span className="text-3xl">✓</span>
              <span className="text-white font-semibold">Sem compromisso</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
              <span className="text-3xl">✓</span>
              <span className="text-white font-semibold">Resposta em minutos</span>
            </div>
          </div>

          {/* Stats visuales grandes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all"></div>
              <div className="relative bg-bg-card border-2 border-border-strong rounded-2xl p-8 hover:border-brand-primary transition-all">
                <div className="w-16 h-16 bg-brand-primary rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <p className="text-5xl font-black text-brand-primary mb-2">+300</p>
                <p className="text-gray-400 font-semibold">Alunos ativos</p>
              </div>
            </div>
            
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all"></div>
              <div className="relative bg-bg-card border-2 border-border-strong rounded-2xl p-8 hover:border-brand-primary transition-all">
                <div className="w-16 h-16 bg-brand-primary rounded-full flex items-center justify-center mx-auto mb-4">
                  <TrendingUp className="w-8 h-8 text-white" />
                </div>
                <p className="text-5xl font-black text-brand-primary mb-2">15+</p>
                <p className="text-gray-400 font-semibold">Anos de experiência</p>
              </div>
            </div>
            
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all"></div>
              <div className="relative bg-bg-card border-2 border-border-strong rounded-2xl p-8 hover:border-brand-primary transition-all">
                <div className="w-16 h-16 bg-brand-primary rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="w-8 h-8 text-white" />
                </div>
                <p className="text-5xl font-black text-brand-primary mb-2">4.9★</p>
                <p className="text-gray-400 font-semibold">Avaliação média</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
